var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",on:{"click":_vm.deselectElements}},[_c('div',{staticClass:"focusSlide"},[_c('SlideWrapper',{key:_vm.currentSlide.$url,style:(_vm.getZoomFactor),attrs:{"slide":_vm.currentSlide,"index":_vm.currentIndex,"islast":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }